import Role from "../../services/role"
import * as types from "../mutationTypes";

let state = {
    role: null,
    roles: null,
    error: null
}
let getters = {
    roles (state) {
        return state.roles
    },
    role (state) {
        return state.role
    },
    error (state)
    {
        return state.error
    }
}
const mutations = {

    [types.REQUEST_GET_ALL_ROLES_SUCCESS] (state, roles) {
        state.roles = roles
        state.error = null
    },
    [types.REQUEST_GET_ALL_ROLES_ERROR] (state, message) {
        state.error = message
        state.roles = null
    },
    [types.REQUEST_GET_ROLE_BY_ID_SUCCESS] (state, role) {
        state.role = role
        state.error = null
    },
    [types.REQUEST_GET_ROLE_BY_ID_ERROR] (state, message) {
        state.error = message
        state.role = null
    },

}
const actions = {

    async loadRoles ({ commit }) {
        try {
            let res = await Role.get()
            if (res) {
                commit(types.REQUEST_GET_ALL_ROLES_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ALL_ROLES_ERROR, error.message)
        }
    },
    async getById ({ commit }, id) {
        try {
            let res = await Role.getById(id)
            if (res) {
                commit(types.REQUEST_GET_ROLE_BY_ID_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_ROLE_BY_ID_ERROR, error.message)
        }
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
